export function sanitizeODateFilterValue(value: string | undefined) {
  if (value === undefined) {
    return "";
  }
  const quoteCount = (value.match(/'/g) || []).length;

  return quoteCount % 2 !== 0 ? value.replace(/'/g, "''") : value;
}
